"use client"

import { Tooltip as ChakraTooltip, Portal } from "@chakra-ui/react"
import * as React from "react"

type ChakraTooltipRootProps = React.ComponentProps<typeof ChakraTooltip.Root>

export interface TooltipProps extends ChakraTooltipRootProps {
  content: React.ReactNode
  children: React.ReactElement
}

export const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>(
  function Tooltip(props, ref) {
    const { children, content, positioning, ...rest } = props
    return (
      <ChakraTooltip.Root positioning={positioning} {...rest}>
        <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>
        <Portal>
          <ChakraTooltip.Positioner>
            <ChakraTooltip.Content ref={ref}>{content}</ChakraTooltip.Content>
          </ChakraTooltip.Positioner>
        </Portal>
      </ChakraTooltip.Root>
    )
  },
)
